import { TextArea } from "../components/TextArea";
import type { TextAreaProps } from "../components/TextArea";

export function getControllerTextAreaRender(props: TextAreaProps) {
  return ({ field }: any) => <TextArea {...field} {...props} />;
}
